import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import {
  Panel,
  Row,
  Table,
  ButtonGroup,
  Message,
  IconButton,
  Icon,
  Button,
  Col,
  DatePicker,
  Form,
} from 'rsuite'
import {
  getContractAttachment,
  updateCheckAttachments,
  getDownloadAttachmentGrantee,
  getDownloadContractPdf,
  getDownloadContractPdfRealtime,
  getDownloadProposalPdfRealtime,
  contractRequest,
} from '../../redux/actions/contract'
import { startLoading, doneLoading } from '../../utils/loading'
import TooltipButton from '../../components/buttons/TooltipButton'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../constants/date'
import { useForm, Controller } from 'react-hook-form'
import { isValidators, requiredFiled, getMaxLengthData } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import moment from 'moment'

export default function AttachFilesContractWidget(props) {
  const { Column, HeaderCell, Cell } = Table
  const { isContractCenter, isContractFile, isShowButtonMakeContract } = props
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()

  const [schema, setSchema] = useState(props.schema)
  const [isError, setIsError] = useState(false)
  const [isSucceed, setIsSucceed] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [fileId, setFileId] = useState(false)
  const [dataTable, setDataTable] = useState([])

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if(props.schema?.attachFiles?.value) {
      setDataTable(schema?.attachFiles?.value?.filter((item) => item.path) || [])
    }
  }, [props.schema])

  const callGetDownloadService = async (fileObj, type) => {
    startLoading()
    try {
      let file
      if (isContractFile) {
        file = await getDownloadContractPdf(projectId, fileObj.name)
      } else {
        file = await getDownloadAttachmentGrantee(projectId, fileObj.id)
      }

      const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
      const link = document.createElement('a')
      link.href = url
      if (type == 'download') {
        link.setAttribute('download', fileObj.name)
      } else {
        link.target = '_blank'
        link.setAttribute('value', fileObj.name)
      }

      document.body.appendChild(link)
      setIsError()
      link.click()
    } catch (e) {
      //generate real time when no file in DB
      try {
        let file
        if (isContractFile) {
          if (fileObj.name == 'contract') file = await getDownloadContractPdfRealtime(projectId)
          if (fileObj.name == 'proposal') file = await getDownloadProposalPdfRealtime(projectId)
        }

        const url = window.URL.createObjectURL(new Blob([file], { type: file.type }))
        const link = document.createElement('a')
        link.href = url
        if (type == 'download') {
          link.setAttribute('download', fileObj.name)
        } else {
          link.target = '_blank'
          link.setAttribute('value', fileObj.name)
        }

        document.body.appendChild(link)
        setIsError()
        link.click()
      } catch (e) {
        if (type == 'download') {
          setIsError('ดาวน์โหลดไม่สำเร็จ ' + e?.response?.status + ' ' + e?.response?.statusText)
        } else {
          setIsError('แสดงไม่สำเร็จ ' + e?.response?.status + ' ' + e?.response?.statusText)
        }
      }
    }
    doneLoading()
  }

  const onDownload = (fileObj) => {
    callGetDownloadService(fileObj, 'download')
  }

  const onPreview = (fileObj) => {
    callGetDownloadService(fileObj, 'preview')
  }

  const handleCallService = async () => {
    // console.log('req555522 => ', request)
    setIsLoading(true)
    startLoading()
    setIsError(false)
    try {
      const response = await updateCheckAttachments(projectId, fileId)

      if (response.success) {
        //success jump to new page
        setIsError(false)
        const res = await getContractAttachment(projectId)
        if (res.success) {
          setSchema(res?.model?.forms?.attachmentGrantee)
        }
      }
      setShowConfirm(false)
    } catch (e) {
      setShowConfirm(false)
      setIsError('บันทึก')
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleOnClickCheckFile = (rowData) => {
    setFileId(rowData.id)
    setShowConfirm(true)
  }

  const handleSubmitContract = async (data) => {
    console.log('handleSubmitContract ', data)

    setIsLoading(true)
    startLoading()
    setIsError(false)
    setIsSucceed(false)

    const request = {
      // contractDate: moment(data.contractDate, 'DD/MM/YYYY').toDate(),
      contractDate: moment(data.contractDate, 'DD/MM/YYYY').toDate().toLocaleDateString('en-ZA'),
    }

    console.log('request request ', request)

    try {
      const response = await contractRequest(request, projectId)
      if (response.success) {
        setIsError(false)
        setIsSucceed(true)
        setSchema(response?.model?.forms?.contractFile)
      }
    } catch (e) {
      console.error(e)
      setIsError(e?.response?.data?.errorMessage)
    }
    doneLoading()
    setIsLoading(false)
  }

  return (
    <Panel
      shaded
      header={schema.header}
      bordered
      collapsible
      defaultExpanded
      style={{ marginBottom: 10 }}
    >
      <Row style={{ marginBottom: 10 }}>
        {isError && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="error" description={isError} />
          </Row>
        )}

        {isSucceed && (
          <Row style={{ marginBottom: 10 }}>
            <Message showIcon type="success" description={'การขอทำสัญญาสำเร็จ'} />
          </Row>
        )}

        {isContractCenter && schema?.attachFiles?.value.filter((item) => item.path).length > 0 && (
          <Row style={{ marginBottom: 10 }}>
            <Message
              showIcon
              type="info"
              description={
                'การบันทึกตรวจสอบไฟล์ ทำให้ผู้รับทุนไม่สามารถแก้ไขไฟล์แนบนั้นๆได้ โปรดแน่ใจว่าได้ตรวจสอบเอกสารเรียบร้อยแล้ว ก่อนกดปุ่มบันทึกตรวจสอบไฟล์'
              }
            />
          </Row>
        )}

        {isShowButtonMakeContract && schema?.contractDate && (
          <>
            <Form>
              <Row>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <div style={{ marginBottom: 10 }}>
                    <ErrorMessage error={errors[schema.contractDate.name]} />
                  </div>
                </Col>
                <Col xs={18} sm={18} md={4} lg={4}>
                  <Controller
                    name={schema.contractDate.name}
                    control={control}
                    defaultValue={
                      schema.contractDate.value
                        ? moment(schema.contractDate.value, 'DD/MM/YYYY').toDate()
                        : null
                    }
                    rules={isValidators(schema.contractDate.validators)}
                    render={(props) => {
                      return (
                        <DatePicker
                          format="DD/MM/YYYY"
                          locale={LOCAL_DAY_TH}
                          block
                          placement="auto"
                          value={props.value}
                          onChange={(value) => {
                            console.log('value ', value)
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                </Col>
                <Col xs={6} sm={6} md={20} lg={20}>
                  <Button
                    style={{ width: 'auto' }}
                    // appearance="ghost"
                    color="rgb(45, 168, 136)"
                    appearance="primary"
                    onClick={handleSubmit(handleSubmitContract)}
                    loading={isLoading}
                  >
                    {schema.contractButtonText}
                  </Button>
                </Col>
              </Row>

              <br />
            </Form>
          </>
        )}

        <Table
          height={400}
          autoHeight={schema?.attachFiles?.value?.length <= 6}
          wordWrap
          bordered
          data={
            dataTable
            //schema?.attachFiles?.value?.filter((item) => item.path) || []
            //: schema?.attachFiles?.value || []
          }
        >
          <Column width={70} align="center" fixed>
            <HeaderCell>ลำดับ</HeaderCell>
            <Cell>
              {(_, index) => {
                return index + 1
              }}
            </Cell>
          </Column>
          {!isContractFile && (
            <Column minWidth={150} flexGrow={1}>
              <HeaderCell>ประเภทเอกสาร</HeaderCell>
              <Cell dataKey="contractFileType" />
            </Column>
          )}
          <Column minWidth={200} flexGrow={1}>
            <HeaderCell>ชื่อเอกสาร</HeaderCell>
            <Cell dataKey="label" />
          </Column>
          {/* <Column width={100}>
            <HeaderCell>ขนาด</HeaderCell>
            <Cell>
              {(rowData) => {
                return `${rowData.size} Mb`
              }}
            </Cell>
          </Column> */}
          {!isContractFile && (
            <Column width={110}>
              <HeaderCell>อัพโหลดเมื่อ</HeaderCell>
              {/* <Cell dataKey="uploadDate" /> */}
              <Cell>
                {(rowData) => {
                  const newDate = new Date(rowData.uploadDate)
                  const date = newDate.toLocaleDateString()
                  const year = newDate.getFullYear()
                  const time = newDate.setHours(newDate.getHours() + 0)

                  if (year < 2000) {
                    return
                  }
                  return `${date + ' ' + new Date(time).toLocaleTimeString('th-TH')}`
                }}
              </Cell>
            </Column>
          )}

          <Column width={103} fixed="right">
            <HeaderCell></HeaderCell>
            <Cell style={{ marginRight: 20 }}>
              {(rowData) => {
                return (
                  <ButtonGroup>
                    <TooltipButton
                      icon="eye"
                      tooltip={`แสดง`}
                      onClick={(e) => onPreview(rowData)}
                    ></TooltipButton>
                    <TooltipButton
                      icon="download"
                      tooltip={`ดาวน์โหลด`}
                      onClick={(e) => onDownload(rowData)}
                    ></TooltipButton>
                  </ButtonGroup>
                )
              }}
            </Cell>
          </Column>

          {isContractCenter && (
            <Column width={210} fixed="right">
              <HeaderCell></HeaderCell>
              <Cell style={{ marginRight: 20 }}>
                {(rowData) => {
                  return (
                    <IconButton
                      icon={
                        <Icon
                          icon="check-circle"
                          style={{ color: rowData.isChecked ? '#14997a' : '#8e8e93' }}
                        />
                      }
                      tooltip={`แสดง`}
                      onClick={(e) => handleOnClickCheckFile(rowData)}
                    >
                      บันทึกตรวจสอบไฟล์
                    </IconButton>
                  )
                }}
              </Cell>
            </Column>
          )}
        </Table>
      </Row>

      <ConfirmWidget
        size={'sm'}
        title={`บันทึกตรวจสอบไฟล์`}
        show={showConfirm}
        detail={`การบันทึกตรวจสอบไฟล์ ทำให้ภาคีไม่สามารถลบไฟล์นี้ได้อีก`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </Panel>
  )
}

const schema = {
  header: 'รายการไฟล์แนบทั้งหมด',
  buttonText: '',
  attachFiles: {
    id: null,
    name: 'attachFiles',
    value: [
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน (ร่าง)',
        name: 'icon-chat.JPG',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.JPG',
        uploadDate: '16 ม.ย. 2564',
        type: 'jpg',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9D',
      },
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน',
        name: 'icon-chat.pdf',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.pdf',
        uploadDate: '17 ม.ย. 2564',
        type: 'pdf',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9E',
      },
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน',
        name: 'icon-chat.pdf',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.pdf',
        uploadDate: '17 ม.ย. 2564',
        type: 'pdf',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9E',
      },
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน',
        name: 'icon-chat.pdf',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.pdf',
        uploadDate: '17 ม.ย. 2564',
        type: 'pdf',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9E',
      },
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน',
        name: 'icon-chat.pdf',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.pdf',
        uploadDate: '17 ม.ย. 2564',
        type: 'pdf',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9E',
      },
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน',
        name: 'icon-chat.pdf',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.pdf',
        uploadDate: '17 ม.ย. 2564',
        type: 'pdf',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9E',
      },
      {
        docType: 'สัญญา',
        label: 'ข้อตกลงรับทุน',
        name: 'icon-chat.pdf',
        path: 'proposal/appendix/D0FFF22E-53CB-4691-A05F-98E1E1EC71A0.pdf',
        uploadDate: '17 ม.ย. 2564',
        type: 'pdf',
        size: 0,
        id: '3FA506BE-6CB2-48B5-8917-DB4DCE8F8D9E',
      },
    ],
  },
}
